import {
    SET_PASSWORD,
    SET_PASSWORD_SUCCESSFUL,
    SET_PASSWORD_FAILED,
  } from "./actionTypes"
  
  export const setPassword = user => {
    return {
      type: SET_PASSWORD,
      payload: { user },
    }
  }
  
  export const setPasswordSuccessful = user => {
    return {
      type: SET_PASSWORD_SUCCESSFUL,
      payload: user,
    }
  }
  
  export const setPasswordFailed = user => {
    return {
      type: SET_PASSWORD_FAILED,
      payload: user,
    }
  }
  